<template>
    <el-dialog title="编辑" :visible="visible" width="40%" @close="close">
        <el-form ref="form" :model="form" label-width="100px" size="small">
            <el-form-item label="上级菜单" prop="company_id" :rules="{ required: true, message: '不能为空', trigger: 'blur' }">
                <select-hospital v-model="form.company_id" />
            </el-form-item>
            <el-form-item label="名称" prop="username" :rules="{ required: true, message: '不能为空', trigger: 'blur' }">
                <el-input v-model.trim="form.username"></el-input>
            </el-form-item>
            <el-form-item label="图标" prop="icon" :rules="{ required: true, message: '不能为空', trigger: 'blur' }">
                <select-icon v-model="form.icon" />
            </el-form-item>
            <el-form-item label="地址" prop="name" :rules="{ required: true, message: '不能为空', trigger: 'blur' }">
                <select-route v-model="form.url" />
            </el-form-item>
            <el-form-item label="排序" prop="contact" :rules="{ required: true, message: '不能为空', trigger: 'blur' }">
                <el-input v-model.trim="form.contact"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="textarea" v-model.trim="form.remarks"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">{{ $t('form.cancel') }}</el-button>
            <el-button @click="formSubmit" type="primary" :loading="loading" :disabled="loading">{{ $t('form.ok') }}
            </el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        visible: {
            default: false
        },
        form: {
            hospital: null,
            default: {}
        },
        isNew: {
            default: false
        }
    },
    data() {
        return {
            loading: false,
            icons: ['el-icon-setting', 'el-icon-help']
        }
    },
    methods: {
        async formSubmit() {
            const valid = await this.$refs['form'].validate().catch(() => false)
            if (!valid) return
            const resp = await this.$http.post('/user', this.form)
            if (resp.data.code != 200) {
                this.$message.error(resp.data.msg)
            } else {
                this.$message.success('保存成功')
                this.$emit('update')
                this.$emit('close')
            }
        },
        close() {
            this.$emit('close')
        }
    },
    mounted() {

    }
}
</script>

<style scoped>
::v-deep .el-dialog__body {
    padding: 0 20px;
}
</style>
